import i18n from "i18next";
import ICU from "i18next-icu";
import de from "i18next-icu/locale-data/de";
import { initReactI18next } from "react-i18next";
import { english } from "./translations/english";
import { spanish } from "./translations/spanish";

const resources = {
  en: {
    translation: english,
  },
  es: {
    translation: spanish,
  },
};

i18n
  .use(new ICU({ localeData: de }))
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.language ? localStorage.language : "en",
    keySeparator: false,
    fallbackLng: "en",
    interpolation: { escapeValue: false },
  });

export default i18n;
